import { render, staticRenderFns } from "./RentTaxExemptItems.vue?vue&type=template&id=72ffbc48&"
import script from "./RentTaxExemptItems.vue?vue&type=script&lang=js&"
export * from "./RentTaxExemptItems.vue?vue&type=script&lang=js&"
import style0 from "./RentTaxExemptItems.vue?vue&type=style&index=0&id=72ffbc48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports